import { AgentType } from '../models/agent';
import { IUserReadModel, IUserScope, IUserWriteModel } from '../models/user';

export const createAgentScope = (agentType: AgentType): IUserScope => ({
    name: 'bp.access',
    claims: [{ type: 'buzzplus.role', value: agentType }],
});

export const stringToAgentType = (str: string): AgentType | null => {
    switch (str.toLowerCase()) {
        case 'agent':
            return 'agent';
        case 'supervisor':
            return 'supervisor';
        default:
            return null;
    }
};

export const getAgentType = (user: IUserReadModel | IUserWriteModel): AgentType | null => {
    const scope = user.scopes?.find(s => s.name === 'bp.access');

    const type = scope?.claims?.find(c => c.type === 'buzzplus.role')?.value ?? '';
    return stringToAgentType(type);
};

export const updateUserWithAgentType = (user: IUserWriteModel, agentType: AgentType): IUserWriteModel => {
    const scopes = [...user.scopes?.filter(s => s.name !== 'bp.access') ?? [], createAgentScope(agentType)];
    return { ...user, scopes };
};
